<style lang="scss" scoped>
.card {
  margin-right: 12px;
}

::v-deep .el-progress-bar__outer {
  background: #606672;
}

::v-deep .el-progress__text {
  color: #ffffff;
}

::v-deep::before {
  z-index: inherit;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #33333a !important;
}

::v-deep.el-table {
  background-color: transparent;
}

::v-deep.el-table--border:after,
::v-deep.el-table--group:after,
::v-deep.el-table:before {
  background-color: transparent;
}

::v-deep.el-table tr {
  background-color: transparent;
}

::v-deep.el-table td.gutter,
::v-deep.el-table th.gutter {
  background: #33333a;
}

::v-deep .el-table__body-wrapper {
  background: #1d1d24;
}

// 滚动条的宽度
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

::v-deep .el-progress__text {
  flex-shrink: 0;
}

// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.gridMode::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

.gridMode::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
::v-deep .progress-green {
  .el-progress__text {
    color: #39f16d !important;
  }
}

::v-deep .progress-yellow {
  .el-progress__text {
    color: #ffc83a !important;
  }
}

::v-deep .progress-red {
  .el-progress__text {
    color: #ff3a5e !important;
  }
}

::v-deep .progress-gray {
  .el-progress__text {
    color: #99a0ad !important;
  }
}

::v-deep .el-progress-bar__outer {
  background: #515c69;
}

.gridMode .el-progress-bar__outer {
  background: #515c69;
}

::v-deep.el-progress {
  display: flex;
  align-items: center;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('shengchanjindu') }}
        </p>
        <div style="display: flex;margin-left: 24px;align-items: center;">
          <div style="display: flex;align-items: center;">
            <div style="width: 8px;height: 8px;border-radius: 50%;background-color: white;"></div>
            <div style="font-size: 14px;font-weight: bold;color: white;margin-left: 4px;">{{ $t('zongshu') }}</div>
            <div style="font-size: 14px;font-weight: bold;;color: white;margin-left: 4px;">{{ equipmentsPoints.run + equipmentsPoints.idle + equipmentsPoints.fault + equipmentsPoints.offline }}</div>
          </div>
          <div style="display: flex;align-items: center;margin-left: 24px;">
            <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #39F16D;"></div>
            <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ $t('yunxing') }}</div>
            <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ equipmentsPoints.run }}</div>
          </div>
          <div style="display: flex;align-items: center;margin-left: 24px;">
            <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FFC83A;"></div>
            <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ $t('kongxian') }}</div>
            <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ equipmentsPoints.idle }}</div>
          </div>
          <div style="display: flex;align-items: center;margin-left: 24px;">
            <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FF3A5E;"></div>
            <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{ $t('guzhang') }}</div>
            <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{ equipmentsPoints.fault }}</div>
          </div>
          <div style="display: flex;align-items: center;margin-left: 24px;">
            <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #99A0AD;"></div>
            <div style="font-size: 14px;font-weight: bold;;color: #99A0AD;margin-left: 4px;">{{ $t('lixian') }}</div>
            <div style="font-size: 14px;font-weight: bold;;color: #99A0AD;margin-left: 4px;">
              {{ equipmentsPoints.offline }}
            </div>
          </div>
        </div>
      </div>
      <div style="margin-left: 18px;display: flex;">
        <div @click="showMode = 'grid'" :style="{ 'background-color': showMode == 'grid' ? 'rgba(65, 159, 255, 0.2)' : '' }" style="width: 28px;height: 24px;display: flex;justify-content: center;align-items: center;cursor: pointer;">
          <i style="font-size: 14px;color: #419FFF;" class="yicon yicon-a-grid_fill1"></i>
        </div>
        <div @click="showMode = 'list'" :style="{ 'background-color': showMode == 'list' ? 'rgba(65, 159, 255, 0.2)' : '' }" style="width: 28px;height: 24px;display: flex;justify-content: center;align-items: center;cursor: pointer;margin-left: 10px;">
          <i style="font-size: 14px;color: #419FFF;" class="yicon yicon-list_check"></i>
        </div>

      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table v-show="showMode == 'list'" ref="table" class="productionRowTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="{ background: '#1D1D24', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: '#33333A' }">
        <template v-for="(col, index) in monitorSetting.PRODUCTION_COLUMNS">
          <el-table-column prop="equipmentName" v-if="col == 'shebeimingcheng'" :label="$t('shebeimingcheng')"> </el-table-column>
          <el-table-column prop="currentMoldNo" v-else-if="col == 'dangqianmohao'" :label="$t('dangqianmohao')"> </el-table-column>
          <el-table-column prop="currentMaterialNo" v-else-if="col == 'dangqianliaohao'" :label="$t('dangqianliaohao')"> </el-table-column>
          <el-table-column prop="equipmentStatus" v-else-if="col == 'shebeizhuangtai'" :label="$t('shebeizhuangtai')">
            <template slot-scope="scope">
              <div style="line-height: 28px;">
                <span v-if="scope.row.equipmentStatus == 0" style="color:#39F16D;border: 1px solid #39F16D;background: rgba(57, 241, 109, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('yunxingzhong') }}</span>
                <span v-if="scope.row.equipmentStatus == 1" style="color:#FFC83A;border: 1px solid #FFC83A;background: rgba(255, 200, 58, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('kongxian') }}</span>
                <span v-if="scope.row.equipmentStatus == 3" style="color:#FF3A5E;border: 1px solid #FF3A5E;background: rgba(255, 58, 94, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('guzhang') }}</span>
                <span v-if="scope.row.equipmentStatus == -1" style="color:#99A0AD;border: 1px solid #99A0AD;background: rgba(153, 160, 173, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('lixian') }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'jihuachanliang'" :label="$t('jihuachanliang')">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.planProduct).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'jihuachanliangziding'" :label="$t('jihuachanliangziding')">
            <template slot-scope="scope">
              <span v-if="scope.row.customPlanProduct != null">
                {{ parseFloat(scope.row.customPlanProduct).toFixed(0) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'leijichanliang'" :label="$t('leijichanliang')">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.totalProduct).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'banzhichanliang'" :label="$t('banzhichanliang')">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.shiftProduct).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'shangyimozhouqi'" :label="$t('shangyimozhouqi') + '(s)'">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.actualCycle).toFixed(1) }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'shengchanjindu'" :label="$t('shengchanjindu')" min-width="80">
            <template slot-scope="scope">
              <circle_progress :percent="scope.row.productionProgress" :color="cardTextColor(scope.row.equipmentStatus)" :desc="$t('shengchanjindu')" :canvasId="'web_monitor_production_list_' + scope.$index" :key="scope.$index"></circle_progress>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'shengchanjinduziding'" :label="$t('shengchanjinduziding')" min-width="80">
            <template slot-scope="scope">
              <circle_progress :percent="scope.row.customProductionProgress != null ? scope.row.customProductionProgress * 100 : 0" :color="cardTextColor(scope.row.equipmentStatus)" :desc="$t('shengchanjinduziding')" :canvasId="'2_web_monitor_production_list_' + scope.$index" :key="scope.$index + '_2'"></circle_progress>
            </template>
          </el-table-column>
          <el-table-column v-else-if="col == 'wangongyuceshijian'" :label="$t('wangongyuceshijian')" width="160">
            <template slot-scope="scope">
              {{ scope.row.expectedCompletionTime != null ? dayjs.unix(scope.row.expectedCompletionTime / 1000).format('YYYY-MM-DD HH:mm') : '' }}
            </template>
          </el-table-column>
        </template>
      </el-table>

      <div class="gridMode" v-show="showMode == 'grid'" ref="grids" :style="{ height: contentHeight + 'px' }" style="padding-top: 0;display: flex;;overflow: auto;width: 100%;flex-flow: wrap;">
        <div class="card" style="background: #121212;padding:20px;border-radius: 2px;flex-shrink: 0;margin-top: 12px;" :style="{ width: monitorSetting.PRODUCTION_CARD_WIDTH + 'px' }" v-for="(progress, index) in progresses">
          <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 30px;font-weight: 700;flex-shrink: 0;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ progress.equipmentName }}</p>
          <div style="width: 100%;height: 1px;background: #606672;margin: 8px 0;"></div>
          <div style="display: flex;justify-content: space-between;" :ref="'container_' + progress.id">
            <div style="width: 40%;display: flex;justify-content: center;align-items: center;">
              <div style="width: 100%;">
                <template v-for="(col, index2) in monitorSetting.PRODUCTION_COLUMNS">
                  <div v-if="col == 'shengchanjindu'">
                    <circle_progress_360 :percent="progress.productionProgress != null ? progress.productionProgress * 100 : 0" :color="cardTextColor(progress.equipmentStatus)" :desc="$t('shengchanjindu')" :canvasId="'web_monitor_production_grid_' + index" :key="index"></circle_progress_360>
                  </div>
                  <div v-if="col == 'shengchanjinduziding'">
                    <circle_progress_360 :percent="progress.customProductionProgress != null ? progress.customProductionProgress * 100 : 0" :color="cardTextColor(progress.equipmentStatus)" :desc="$t('shengchanjinduziding')" :canvasId="'2_web_monitor_production_grid_' + index" :key="index + '_2'"></circle_progress_360>
                  </div>
                </template>
              </div>
            </div>

            <div style="width: 60%;margin-left: 10px; display: flex;flex-direction: column;justify-content: space-between;">
              <template v-for="(col, index2) in monitorSetting.PRODUCTION_COLUMNS">
                <div v-if="col == 'banzhichanliang'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('banzhichanliang') }}：</p>
                  <p :style="{ color: cardTextColor(progress.equipmentStatus), 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.shiftProduct.toFixed(0) }}</p>
                </div>
                <div v-if="col == 'leijichanliang'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('leijichanliang') }}：</p>
                  <p :style="{ color: cardTextColor(progress.equipmentStatus), 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.totalProduct.toFixed(0) }}</p>
                </div>
                <div v-if="col == 'jihuachanliang'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('jihuachanliang') }}：</p>
                  <p :style="{ color: cardTextColor(progress.equipmentStatus), 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.planProduct && progress.planProduct.toFixed(0) }}</p>
                </div>
                <div v-if="col == 'jihuachanliangziding'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('jihuachanliangziding') }}：</p>
                  <p v-if="progress.customPlanProduct != null" :style="{ color: cardTextColor(progress.equipmentStatus), 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.customPlanProduct.toFixed(0) }}</p>
                </div>
                <div v-if="col == 'shangyimozhouqi'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('shangyimozhouqi') }}(s)：</p>
                  <p :style="{ color: '#FFFFFF', 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.actualCycle.toFixed(1) }}</p>
                </div>
                <div v-if="col == 'wangongyuceshijian'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('wangongyuce') }}：</p>
                  <p :style="{ color: '#FFFFFF', 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;">{{ progress.expectedCompletionTime != null ? dayjs.unix(progress.expectedCompletionTime / 1000).format('YY-MM-DD HH:mm') : '' }}</p>
                </div>
                <div v-if="col == 'dangqianliaohao'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('dangqianliaohao') }}：</p>
                  <p :style="{ color: '#FFFFFF', 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.currentMaterialNo }}</p>
                </div>
                <div v-if="col == 'dangqianmohao'" style="display:flex;margin-top:2px;flex-shrink: 0;">
                  <p :style="{ 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="flex-shrink:0;color: #C0C4CC;font-size: 14px;">{{ $t('dangqianmohao') }}：</p>
                  <p :style="{ color: '#FFFFFF', 'font-size': monitorSetting.PRODUCTION_CARD_FONT_SIZE + 'px' }" style="font-size: 14px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ progress.currentMoldNo }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_production_row',
  components: {},
  data() {
    return {
      flowHeights: {},
      flowWidths: {},
      x6s: {},
      monitorSetting: {},
      interval: null,
      timmer: null,
      contentHeight: 0,
      rowHeight: 0,
      progresses: [],
      showMode: 'grid',
      isStopListScroll: false,
      isStopGridScroll: false,
      equipments: [],
      equipmentIds: [],
      equipmentsPoints: {}
    };
  },
  created() {
    this.timmer = setInterval(() => {
      this.listProductionProgress();
      this.getMonitorData();

    }, 120000);
    this.listProductionProgress();
    this.getMonitorData();
  },
  mounted() {
    this.resize();
    this.setProduction();
    this.utils.event_hub.$on('SetProduction', () => {
      this.setProduction();
    });
    this.utils.event_hub.$on('UpdatePlanProduction', () => {
      this.listProductionProgress();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    this.utils.event_hub.$off('SetProduction');
    this.utils.event_hub.$off('UpdatePlanProduction');
    clearInterval(this.timmer);
  },
  activated() { },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listProductionProgress();
    },
    showMode(newValue, oldValue) { }
  },
  computed: {
    cardTextColor() {
      return index => {
        return {
          '0': '#39F16D',
          '3': '#FF3A5E',
          '1': '#FFC83A',
          '-1': '#99A0AD'
        }[index];
      };
    },
    cardTextClass() {
      return index => {
        return {
          '0': 'progress-green',
          '3': 'progress-red',
          '1': 'progress-yellow',
          '-1': 'progress-gray'
        }[index];
      };
    }
  },
  methods: {
    setProduction() {
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
      this.listProductionProgress();
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      const gridDiv = this.$refs.grids;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
        if (!this.isStopGridScroll) {
          gridDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
            this.isStopGridScroll = true;
            setTimeout(() => {
              if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
                gridDiv.scrollTop = 0;
              }
              this.isStopGridScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    async listProductionProgress() {
      let response = await this.http.get('/web/productionProgress/list', {
        params: {
          orgId: this.$attrs.orgId
        }
      });

      this.progresses = response.data;

      this.progresses = this.progresses.filter(item => {
        return this.monitorSetting.PRODUCTION_STATUS_SHOW_TYPE == 'moren' || item.equipmentStatus != -1;
      });
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar == null) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 10;
      }, 800);
    },
    getMonitorData() {
      const req = this.http.get('web/equipment/home/getEquipmentStateSum', {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      req.then(r => {
        Object.assign(this.equipmentsPoints, r.data);
      });
    }
  }
};
</script>
